import React from 'react';
import Modal from './Modal';
import f from './forms.module.css';

/**
 * One-time launch promo for the 2025-2026 Year in Review.
 * Shown once per visitor (localStorage) until PROMO_ENDS — see App.js.
 * Both paths (read or continue) dismiss it for good.
 */
export default function YearInReviewPromo({ onClose }) {
  return (
    <Modal open onClose={onClose} label="The 2025-2026 Year in Review" size="md">
      <span className={f.label}>Year One · 2025-2026</span>
      <h2 className={f.title}>
        A record of the Lord&rsquo;s <em>faithfulness.</em>
      </h2>
      <p className={f.body}>
        Our 2025-2026 Year in Review is out. Enjoy!
      </p>

      <a
        className={f.primary}
        style={{ textDecoration: 'none' }}
        href="/yearinreview"
        onClick={onClose}
      >
        Read the Year in Review
        <span aria-hidden="true">→</span>
      </a>

      <p style={{ marginTop: '1.4rem' }}>
        <button type="button" className={f.linkBtn} onClick={onClose}>
          Continue to the site
        </button>
      </p>
    </Modal>
  );
}
